import React from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button } from '@mui/material';
import LoadingButton from '@mui/lab/LoadingButton';

const ConfirmCancelInvoiceModal = ({
  open,
  loading,
  onCancel,
  onConfirm
}) => {
  return (
    <Dialog
      open={open}
      onClose={() => {}}
      disableEscapeKeyDown
      disableBackdropClick
    >
      <DialogTitle>Confirmar cancelación</DialogTitle>
      <DialogContent>
        ¿Estás seguro de que querés cancelar esta factura? Esta acción no se puede deshacer.
      </DialogContent>
      <DialogActions>
        <Button
          onClick={onCancel}
          color="inherit"
        >
          Cancelar
        </Button>

        <LoadingButton
          color="error"
          loading={loading}
          onClick={onConfirm}
          variant="contained"
        >
          Confirmar
        </LoadingButton>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmCancelInvoiceModal;
